import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { 
    numberReducer
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function BalanceForm({
    closeIt, filterDayOffs
}){
    const user = useMyStore(state => state.user);
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "My Balance"
            width = {400}
            maxWidth = {"100%"}
        >
            <div className = "m-3">
                <div className = "font-weight-bold">
                    Initial Value:
                    <span className = "mx-3 text-primary">
                        {0}
                        &nbsp;
                        hours
                    </span>
                    &nbsp;
                    at 2022-01-01
                </div>
                {filterDayOffs.filter(f => f.requesterEmail === user.email).map((f, fi) => 
                <li key = {fi} className = "mt-2">
                    <span className = "text-info font-weight-bold">
                        {f.requestDates}
                    </span>
                    <span className = "ml-3 text-primary font-weight-bold">
                        -{f.totalHours}
                        &nbsp;
                        hours
                    </span>
                </li>
                )}
                <div className = "mt-2 font-weight-bold">
                    Current Value:
                    <span className = "ml-3 text-primary">
                        {0 - filterDayOffs.filter(f => f.requesterEmail === user.email)
                        .map(f => window.Number.parseFloat(f.totalHours || 0)).reduce(numberReducer, 0)}
                        &nbsp;
                        hours
                    </span>
                </div>
            </div>
        </Modal>
    )
}